import { UpdateAssignmentRecord } from '../types/ElectiveAssignmentTypes';
import { isSubjectAssigned } from './utils';

const updateAssignment = (
  prevChanges: UpdateAssignmentRecord,
  studentId: string,
  subjectKey: string,
  newElectiveAssigned: boolean,
  originalStudent: any
): UpdateAssignmentRecord => {
  const originalElectiveAssigned = isSubjectAssigned(
    originalStudent,
    subjectKey
  );
  const entry = { ...(prevChanges[studentId] || {}) };

  if (newElectiveAssigned === originalElectiveAssigned) {
    delete entry[subjectKey];
    if (!Object.keys(entry).length) {
      const { [studentId]: _, ...rest } = prevChanges;
      return rest;
    }
  } else {
    const subjectData =
      typeof originalStudent[subjectKey] === 'object'
        ? originalStudent[subjectKey]
        : { subjectId: subjectKey };

    entry[subjectKey] = {
      current: newElectiveAssigned,
      original: originalElectiveAssigned,
      subjectId: subjectData.subjectId || subjectData.id || subjectKey,
      id: subjectData.id
    };
  }
  return { ...prevChanges, [studentId]: entry };
};
export { updateAssignment };
